function createButton(className = '') {
    let button = document.createElement('button');
    button.setAttribute('type', 'button');

    if (className !== '') {
        button.className = className;
    }

    return button;
}

module.exports = createButton;